<template>
  <div id="feedback">
    <b-btn
      id="feedbackButton"
      v-b-tooltip.hover.right="'Feedback'"
      @click="$store.commit('toggleModal', 'feedback')"
      class="map-toggle"
    ><i class="fas fa-bullhorn"></i></b-btn>
    <div
      v-if="$store.state.display.modal.feedback"
      class="o-modal"
    >
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="closeFeedback()"
            class="close clickable"
          >
            <i class="far fa-times"></i>
          </a>
          <p class="lead">Provide Feedback</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <p class="lead"><strong>If you need help getting started, <a href="https://every.farm/docs/" target="_blank" rel="noopener noreferrer">read the docs</a>.</strong></p>
          <form @submit.prevent>
            <div class="form-group">
              <label>Please describe the issue you are experienceing.</label>
              <textarea rows="10" placeholder="Be as detailed as possible..." v-model="message" type="text" class="form-control" />
            </div><!-- /.form-group -->
          </form>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="drawer-footer">
            <button
              @click="sendFeedback()"
              class="btn btn-success mr-1 w-50"
            >
              Send
            </button>
            <button
              @click="closeFeedback()"
              class="btn btn-secondary"
            >
              Cancel
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
  </div><!-- /#feedback -->
</template>

<script>
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      message: ''
    }
  },
  methods: {
    sendFeedback () {
      const notificationMessage = 'FEEDBACK: ' + this.$store.state.userProfile.email + ' said: "' + this.message + '"'
      fb.notificationsCollection.add({
        createdOn: new Date(),
        updatedOn: new Date(),
        createdBy: this.$store.state.currentUser.uid,
        farmId: this.$store.state.farm.id,
        subject: 'Every.Farm feedback notification',
        message: notificationMessage,
        recipient: 't0Ap3h86WMekR8H9qzlAu7G7KyO2',
        url: 'https://app.every.farm' + window.location.pathname,
        read: false
      }).then(() => {
        this.message = ''
        this.$store.commit('toggleModal', 'feedback')
        this.$store.commit('setAlert', { active: true, message: 'Thank you for providing feedback! We will address your issue as soon as possible!', level: 'alert-success' })
      }).catch(err => console.log(err))
    },
    closeFeedback () {
      this.$store.commit('toggleModal', 'feedback')
    }
  }
}
</script>

<style scoped>
#feedbackButton {
  position: fixed;
  z-index: 1;
  left: 10px;
  bottom: 120px;
}
</style>
